import { Splide } from '@splidejs/splide';
import { Grid } from '@splidejs/splide-extension-grid';
import '@splidejs/splide/css';

const sliders = {
  init() {
    this.heroSlider();
    this.catSlider();
    this.prodSlider();
    this.setProdThumbnailsSlider();
    this.showcaseSlider();
    this.resetSlider();
  },

  resetSlider() {
    window.addEventListener('reset', () => {
      this.setProdThumbnailsSlider();
    });
  },
  heroSlider() {
    const heroSliders = document.querySelectorAll(
      '.jsHeroSlider',
    ) as NodeListOf<HTMLElement>;

    heroSliders.forEach((el) => {
      const loadSlideImage = (slide: HTMLElement | null) => {
        if (!slide || slide.dataset.imageLoaded === 'true') return;

        const img = slide.querySelector(
          'img[data-src]',
        ) as HTMLImageElement | null;

        if (!img) {
          slide.dataset.imageLoaded = 'true';
          return;
        }

        const dataSrc = img.getAttribute('data-src');

        if (!dataSrc) return;

        img.src = dataSrc;
        img.removeAttribute('data-src');

        slide.dataset.imageLoaded = 'true';
      };

      const slider = new Splide(el, {
        type: 'loop',
        perPage: 1,
        pagination: false,
        arrows: true,
        autoplay: true,
        speed: 600,
        interval: 5000,
        reducedMotion: {
          interval: 5000,
          speed: 600,
          autoplay: true,
        },
      });

      slider.on('mounted move', () => {
        const activeSlide = el.querySelector(
          '.splide__slide.is-active',
        ) as HTMLElement | null;

        const prevSlide = el.querySelector(
          '.splide__slide.is-prev',
        ) as HTMLElement | null;

        const nextSlide = el.querySelector(
          '.splide__slide.is-next',
        ) as HTMLElement | null;

        loadSlideImage(activeSlide);
        loadSlideImage(prevSlide);
        loadSlideImage(nextSlide);
      });

      slider.mount();
    });
  },

  showcaseSlider() {
    const showcaseSliders = document.querySelectorAll(
      '.jsShowcaseSlider',
    ) as NodeListOf<HTMLElement>;

    showcaseSliders.forEach((item) => {
      const slider = new Splide(item, {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        arrows: false,
        pagination: false,
        gap: 25,
        grid: {
          rows: 2,
          cols: 3,
          gap: {
            row: '25px',
            col: '25px',
          },
        },
        breakpoints: {
          1200: {
            grid: {
              rows: 3,
              cols: 2,
              gap: {
                row: '25px',
                col: '25px',
              },
            },
          },
        },
      });
      slider.mount({ Grid });
    });
  },

  catSlider() {
    const sliders = document.querySelectorAll(
      '.jsCatSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'loop',
        pagination: true,
        arrows: false,
        autoplay: true,
        speed: 800,
        destroy: true,
        breakpoints: {
          1200: {
            destroy: false,
            perPage: 2,
            gap: 20,
            padding: { right: '30%' },
          },
        },
      }).mount();
    });
  },

  prodSlider() {
    const sliders = document.querySelectorAll(
      '.jsProdSlider',
    ) as NodeListOf<HTMLElement>;

    sliders.forEach((item) => {
      new Splide(item, {
        type: 'carousel',
        arrows: true,
        pagination: false,
        destroy: true,
        breakpoints: {
          1200: {
            destroy: false,
            perPage: 1,
            grid: {
              rows: 2,
              cols: 3,
              gap: {
                row: '20px',
                col: '20px',
              },
            },
          },

          768: {
            grid: {
              rows: 2,
              cols: 2,
              gap: {
                row: '7px',
                col: '7px',
              },
            },
          },
        },
      }).mount({ Grid });
    });
  },

  setProdThumbnailsSlider() {
    const porductMainImages = document.getElementById('mainImage') as
      | HTMLElement
      | undefined;
    const thumbnails = document.getElementById('thumbnails') as
      | HTMLElement
      | undefined;

    if (porductMainImages && thumbnails) {
      const main = new Splide(porductMainImages, {
        type: 'fade',
        rewind: true,
        pagination: false,
        arrows: true,
        breakpoints: {
          1199: {},
        },
      });

      const thumbnailsNav = new Splide(thumbnails, {
        direction: 'ttb',
        isNavigation: true,
        pagination: false,
        fixedHeight: '60px',
        heightRatio: 6,
        perPage: 4,
        arrows: true,
        gap: '30px',
        breakpoints: {},
      });

      main.sync(thumbnailsNav);
      main.mount();
      thumbnailsNav.mount();
    }
  },
};

export default sliders;
